module.exports = __webpack_public_path__ + "static/img/czlc.50700bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/czlc.jpg
// module id = 9QwO
// module chunks = 1